
<input class="search input-content" [ngClass]="{'border-green': search.length>0}" [value]="search"  
name="search" (change)="setSearch($event)" placeholder="       Buscar"
spellcheck="false" autocomplete="none" #input>